import React, { } from "react";
import moment from 'moment';
import { Button, Glyphicon, FormGroup, ControlLabel, FormControl } from "react-bootstrap";
import FormControlLanguage from "../../../UI/FormControlLanguage";

const RangeLimiter = ({ field, setField, isSaving, type, label }) => {

    const encodeRangeValue = (value) => {
        if (!value) {
            return value;
        }
        if (type === 'date') {
            return moment(value).unix();
        }
        if (type === 'time') {
            return moment('1970-01-01 ' + value).unix();
        }

        return value;
    }

    const decodeRangeValue = (value) => {
        if (!value) return value;
        if (type === 'date') {
            return moment.unix(value).format('YYYY-MM-DD');
        }
        if (type === 'time') {
            return moment.unix(value).format('HH:mm:ss');
        }
        return value;
    }

    return <FormGroup >
        <ControlLabel>
            {label}
        </ControlLabel>
        <div style={{ display: 'flex', gap: '2rem' }}>
            <div style={{ flex: 1 }}>
                <div>От</div>
                <FormControl
                    type={type}
                    value={decodeRangeValue(field.min)}
                    onChange={(e) => setField({ min: encodeRangeValue(e.target.value) })}
                    disabled={isSaving}
                />
            </div>
            <div style={{ flex: 1 }}>
                <div>До</div>
                <FormControl
                    type={type}
                    value={decodeRangeValue(field.max)}
                    onChange={(e) => setField({ max: encodeRangeValue(e.target.value) })}
                    disabled={isSaving}
                />
            </div>
        </div>
    </FormGroup>
}

const RegexpLimiter = ({ field, setField, isSaving }) => {
    return <FormGroup >
        <ControlLabel>
            Regexp
        </ControlLabel>
        <FormControl
            type="text"
            placeholder="[a-zA-Z0-9]"
            value={field.regexp}
            onChange={(e) => setField({ regexp: e.target.value })}
            disabled={isSaving}
        />
    </FormGroup>
}

const OptionsLimiter = ({ field, setField, isSaving }) => {
    const options = field?.options || [];

    const handleAddOption = () => {
        setField({ options: [...options, { value: '', label_ru: '', label_en: '' }] });
    }

    const handleUpdateOption = (idx, data) => {
        setField({ options: options.map((option, index) => index === idx ? ({ ...option, ...data }) : option) });
    }

    const handleDeleteOption = (idx) => {
        setField({ options: options.filter((_, index) => index !== idx) });
    }

    const renderOption = (option, idx) => {
        return <div key={idx} style={{ width: '100%', display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.5rem' }}>
            <div style={{ flex: 1 }}>
                <FormControlLanguage
                    type="text"
                    values={{
                        ru: option.label_ru || '',
                        en: option.label_en || '',
                    }}
                    onChange={{
                        ru: (e) => handleUpdateOption(idx, { label_ru: e.target.value }),
                        en: (e) => handleUpdateOption(idx, { label_en: e.target.value }),
                    }}
                    disabled={isSaving}
                />
            </div>
            <Button bsStyle="danger" disabled={isSaving} style={{ flex: 0 }} onClick={() => handleDeleteOption(idx)}>✕</Button>
        </div>
    }

    return <FormGroup >
        <ControlLabel>
            Варианты
        </ControlLabel>
        <div>
            {options.map((option, idx) => renderOption(option, idx))}
        </div>
        <Button onClick={handleAddOption} disabled={isSaving}><Glyphicon glyph="plus" /></Button>
    </FormGroup>

}

export const limiterTemplates = {
    stringLength: (props) => <RangeLimiter {...props} type={'number'} label={'Длина'} />,
    dateRange: (props) => <RangeLimiter {...props} type={'date'} label={'Диапазон'} />,
    timeRange: (props) => <RangeLimiter {...props} type={'time'} label={'Диапазон'} />,
    numberRange: (props) => <RangeLimiter {...props} type={'number'} label={'Диапазон'} />,
    regexp: (props) => <RegexpLimiter {...props} />,
    options: (props) => <OptionsLimiter {...props} />,
}